import script from "./DoctorListView.vue?vue&type=script&setup=true&lang=js"
export * from "./DoctorListView.vue?vue&type=script&setup=true&lang=js"

import "./DoctorListView.vue?vue&type=style&index=0&id=df36cbd2&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df36cbd2"]])

export default __exports__